import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { RoleTemplate } from "../role-template";

export class RequestRoleTemplate extends RequestBasePageId {

  active?: boolean | null;
  roleTypes?: string[] | null;

}

export class RequestRoleTemplateSet extends RequestBaseSet<RoleTemplate>
{

}

export class ResponseRoleTemplate extends ResponseBasePage<RoleTemplate> {

}


export class ResponseRoleTemplateSet extends ResponseBaseSet<RoleTemplate>{

}
